module.exports = __webpack_public_path__ + "static/media/ico-qr-ean.45892bf8.svg";